<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="Scandal in Scotland, by Karen Hawkins." height="100%" src="images/9781439176016.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?198a8d50